<div class="brand_name">
    Arada Group
</div>
